import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { ChargePointIsOnline } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/charge-point/charge-point-is-online.enum';
import { useTranslation } from 'react-i18next';

export interface ChargePointIsOnlineFilterStateControllerProps {
  value: boolean;
  onRemove: FilteredItemProps['onRemove'];
}

export const ChargePointIsOnlineFilterStateController = ({
  value,
  onRemove,
}: ChargePointIsOnlineFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const chargePointIsOnline = value
    ? ChargePointIsOnline.TRUE
    : value === false
      ? ChargePointIsOnline.FALSE
      : ChargePointIsOnline.ALL;

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem
      icon={value ? 'wifi' : 'wifi-off'}
      label={t(
        `delmonicos-shared-sdk.outputs-charge-point-is-online.${chargePointIsOnline}`,
      )}
      onRemove={onRemove}
    />
  );
};
